(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lp-testimonials').forEach(function (root) {
      var track = root.querySelector('[data-lp-track]');
      if (!track) return;
      root.querySelectorAll('[data-lp-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.lp-review');
          var step = card ? card.getBoundingClientRect().width + 18 : 320;
          var dir = btn.getAttribute('data-lp-dir') === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-promotion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
      var display = gallery.querySelector('[data-lp-display]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-lp-thumb]'));
      var arrows = gallery.querySelectorAll('[data-lp-dir]');
      if (!display || thumbs.length === 0) return;

      var index = 0;

      function render() {
        var btn = thumbs[index];
        var src = btn.getAttribute('data-src') || '';
        var srcset = btn.getAttribute('data-srcset') || '';
        var alt = btn.getAttribute('data-alt') || '';
        display.setAttribute('src', src);
        if (srcset) {
          display.setAttribute('srcset', srcset);
        } else {
          display.removeAttribute('srcset');
        }
        display.setAttribute('alt', alt);
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', index === i);
        });
      }

      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          index = i;
          render();
        });
      });

      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-lp-dir') === 'next' ? 1 : -1;
          index = (index + dir + thumbs.length) % thumbs.length;
          render();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
